import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in

  useEffect(() => {
    const token = localStorage.getItem("sc_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("sc_user", JSON.stringify(r.data)); })
      .catch((e) => {
        const cached = localStorage.getItem("sc_user");
        const status = e.response?.status;
        // Hanya keluar jika token benar-benar tidak sah (401/403).
        // Untuk error lain (jaringan/server sibuk saat reload), pertahankan sesi.
        if (status === 401 || status === 403) {
          localStorage.removeItem("sc_token");
          localStorage.removeItem("sc_user");
          setUser(false);
          return;
        }
        if (cached) { setUser(JSON.parse(cached)); return; }
        setUser(false);
      });
  }, []);

  const login = async (username, password, expectedRole) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (expectedRole && data.user.role !== expectedRole) {
      const err = new Error("role-mismatch");
      err.role = data.user.role;
      throw err;
    }
    localStorage.setItem("sc_token", data.token);
    localStorage.setItem("sc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("sc_token");
    localStorage.removeItem("sc_user");
    setUser(false);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
